exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".property-in-row {  \n  margin-top: 15px; \n}\n\n.header-seccion-form {\n\tbackground-color: #d2d0d0;\t\n}\n\n.letra-en-botones {\n\tfont-size: 1.3em;\n}\n\n.letra-botones {\n\tfont-size: 14px;\n}\n\n.botones-docs {\n\tborder: 1px solid black;\n    width: 50px;\n    height: 50px;\n    color: #ff8a65;\n}\n\n.letras-informacion {\n\tfont-size: 15px;\n}\n\n.truncate {\n\twidth: 120px;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n}\n\n.container-cards {\n\tbackground-color: white !important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/AngularProjects/Angular Projects/Formularios/src/app/components/gestor-firmas/gestor-firmas.component.css
// module id = ../../../../../src/app/components/gestor-firmas/gestor-firmas.component.css
// module chunks = main